export default {
  "HitPaw Online Audio Converter": "HitPaw Conversor de Áudio Online",
  "Convert audios to MP3, AAC, FLAC, WMA and more formats for free.": "Converter áudios para MP3, AAC, FLAC, WMA e muito mais formatos gratuitamente.",
  'HitPaw Online Image Converter': 'HitPaw Conversor de Imagem Online',
  'Convert images to JPG, PNG, BMP, TIFF and more formats for free.': 'Converter imagens para JPG, PNG, BMP, TIFF e muito mais formatos gratuitamente.',
  'HitPaw Online Video Converter': 'Conversor de Vídeo Online HitPaw',
  'Convert videos to any formats as your requirements.': 'Escolha as ferramentas mais adequadas para editar seus vídeos em etapas simples, toque para começar!',
  'Add More Files': 'Adicionar Mais Arquivos',
  'Convert to': 'Converter para',
  'Ready': 'Preparando',
  'Converting': 'Convertendo',
  'Video': 'Vídeo',
  'Audio': 'Áudio',
  'Image': 'Imagem',
  'Retry': 'Tentar novamente',
  'Download All': 'Baixar Tudo',
  'Download Desktop': 'Baixar a versão de Desktop',
  'Continue Editing': 'Continuar a Editar',
  'Convert': 'Converter',
  'Cut': 'Cortar',
  'Speed': 'Velocidade',
  'Crop & Rotate': 'Recortar & Girar',
  'Resize': 'Redimensionar',
  'Extract': 'Extrair',
  'Add Music': 'Adicionar Músicas',
  'Subtitles': 'Legendas',
  'Merge': 'Unir',
  'Watermark Remover': "Remover Marca d'água",
  'Add Watermark': "Adicionar Marca d'água",
  'Please select a file to use': 'Por favor, selecione um arquivo para usar {{work}}',
  'Batch Processing': 'Processamento em Lote',
};
